import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var PetGenderIcon = createIcon({
  displayName: 'PetGenderIcon',
  viewBox: '0 0 32 32',
  path: [/*#__PURE__*/_jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.0013 6.70667V14.7333C13.3613 15.0667 16.0013 17.88 16.0013 21.3333C16.0013 25.0133 13.0146 28 9.33464 28C5.65464 28 2.66797 25.0133 2.66797 21.3333C2.66797 17.88 5.30797 15.0667 8.66797 14.7333V6.73333L5.8813 9.81333L4.89464 8.92L9.33464 4L13.8813 8.97333L12.8946 9.88L10.0013 6.70667ZM4.0013 21.3333C4.0013 24.28 6.38797 26.6667 9.33464 26.6667C12.2813 26.6667 14.668 24.28 14.668 21.3333C14.668 18.3867 12.2813 16 9.33464 16C6.38797 16 4.0013 18.3867 4.0013 21.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.668 4C26.348 4 29.3346 6.98667 29.3346 10.6667C29.3346 14.12 26.6946 16.92 23.3346 17.2667L23.348 22.68H26.7213V24.0133H23.348L23.3346 28H22.0013L22.0146 24.0133H18.668V22.68H22.0146L22.0013 17.2667C18.6413 16.9333 16.0013 14.12 16.0013 10.6667C16.0013 6.98667 18.988 4 22.668 4ZM17.3346 10.6667C17.3346 13.6133 19.7213 16 22.668 16C25.6146 16 28.0013 13.6133 28.0013 10.6667C28.0013 7.72 25.6146 5.33333 22.668 5.33333C19.7213 5.33333 17.3346 7.72 17.3346 10.6667Z",
    fill: "currentColor"
  })]
});
//# sourceMappingURL=PetGenderIcon.js.map